import * as React from 'react';
import styled from 'styled-components';
import MuiDialogContentText, {
    DialogContentTextProps as MuiDialogContentTextProps,
} from '@material-ui/core/DialogContentText';

const StyledDialogContentText = styled(MuiDialogContentText)`
    min-width: 500px;
`;

export type DSDialogContentTextProps = MuiDialogContentTextProps;
export const DSDialogContentText: React.FC<DSDialogContentTextProps> = props => <StyledDialogContentText {...props} />;
DSDialogContentText.displayName = 'DSDialogContentText';
